import type { JSX } from 'solid-js'

export function ClockIcon(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 18" fill="none" aria-hidden="true" {...props}>
      <circle cx="9" cy="9" r="6.75" stroke="currentColor" stroke-width="1.3" />
      <path
        d="M9 5.4v3.9l2.4 1.5"
        stroke="currentColor"
        stroke-width="1.3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
